<div class="row justify-content-center align-items-end">

    <div class="auth-card col-auto">
  
      <div class="auth-blob">
        <img src="assets/blobs/blob-1.svg" alt="skillconomy Blob" class="img-fluid">
      </div>
  
      <div class="card box-shadow">
  
        <div class="card-body">
  
          <div class="logo">
            <img src="assets/logo/skillconomy-logo-blau.svg" alt="skillconomy Logo" class="img-fluid">
          </div>

          <h2 class="text-center mb-5">{{ texts.title | localize }}</h2>

          <form>

            <div class="row align-items-center">
              <div class="col">
                <div class="alert alert-error mt-4" role="alert">
                  <p class="alert-heading mb-0">
                    {{ texts.message | localize }}
                  </p>
                </div>
              </div>


            </div>

            <div class="d-flex justify-content-center">
                <a class="btn btn-primary mt-4" [href]="(texts.mailtoHref | localize) + eMail + '.'">
                    {{ texts.requestLink | localize }}
                  </a>
              </div>
            
          </form>
  
        </div>
  
        <div class="card-footer text-center">
          <small>{{ texts.hasAccount | localize }} <a (click)="goToLogin()">{{ texts.signIn | localize }}</a></small>
        </div>
  
      </div>
  
    </div>
    
    <div class="auth-illu col-auto">
      <img src="assets/illus/skillconomy-bot-waving.svg" alt="skillconomy Illu Bot" class="img-fluid">
    </div>
  
  </div>